import React, {useState, useEffect} from "react";

import {Grid} from "@mui/material";
import {connect} from "react-redux";
import {
    listFunctionTemplates,
    getSharedMunicipalities,
    setFunction,
} from "../../../function.actions";
import {CompPartitionHeader} from "../../../../../components/PartitionHeader";
import {
    hasPermission, PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY,
    PERMISSION_EDIT_OWN_FUNCTIONS
} from "../../../../../permissions";
import {useTranslation} from "react-i18next";
import { CompDropdownNew } from "../../../../../components/newComponents/DropdownNew";
import {listLocations} from "../../../../location/location.actions";
import {
    getOrganizationTree,
    listMunicipalityUsersSilent,
    listOrganizations
} from "../../../../municipality/municipality.actions";
import {updateContentIdentifierChoices} from "../../../../root/root.actions";
import { CompTextFieldNew } from "../../../../../components/newComponents/TextField";
import {getComparator} from "../../../../../utils";
import TooltipInfo from "../../../../../components/Tooltip";
import CustomSnackbar from "../../../../../components/CustomSnackbar";
import {getOrganizations} from "../../../../../components/organizationUtils";
import { ButtonPrimary } from "../../../../../components/newComponents/ButtonPrimary";

const FunctionMunicipalityComponent = (props) => {
    const {
        fieldErrors = {},
        func,
        editorActivated,
        authenticatedUser,
        action,
        municipalitySelect,
        municipalities,
        selectedFunction,
        organizationTree,
    } = props;

    const {t} = useTranslation('translation');

    //const municipalitySelect = hasPermission(PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY, authenticatedUser);

    const [municipalityList, setMunicipalityList] = useState([]);
    const [organizationList, setOrganizationList] = useState([]);
    const [userMunicipality, setUserMunicipality] = useState({})
    const [localFunction, setLocalFunction] = useState(selectedFunction);

    //local state management for dates. For some reason using values disappear from selectedFunction 
    useEffect(() => {
        if (selectedFunction && Object.keys(selectedFunction).length) {
            setLocalFunction(selectedFunction);
        }
    }, [selectedFunction]);

    const headerLabel = t("function.create_new")

    const handleMunicipalityChange = (event, doNotUpdateFunction) => {
        let selectedMunicipality = {}
        municipalities.forEach((municipality) => {
            if (municipality.id === parseInt(event.target.value)) {
                selectedMunicipality = municipality;
            }
        })
        const data = {}
        data['municipalityId'] = selectedMunicipality.id;
        //setSelectedTemplate(null);
        props.listFunctionTemplates(selectedMunicipality.id);
        props.listLocations(selectedMunicipality.id);
        props.listMunicipalityUsersSilent(selectedMunicipality.id);
        props.listOrganizations(selectedMunicipality.id);
        props.getOrganizationTree(selectedMunicipality.id, 10);
        props.updateContentIdentifierChoices(selectedMunicipality.id);
        props.setFunction(data);
    };

    useEffect(() => {
        municipalities.forEach((municipality) => {
            if (municipality.id === authenticatedUser.mainMunicipalityId) {
                setUserMunicipality(municipality)
            }
        })
        const comparator = getComparator();
        const response = [];
        for (var municipality of municipalities) {
            response.push(municipality);
        }
        response.sort((a, b) => comparator.compare(a.name,b.name));
        setMunicipalityList(response);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [municipalities])


    const creatorType = selectedFunction.creatorType;
    const isApiFunction = creatorType === "municipality" || creatorType === "organization";


    useEffect(() => {
        setOrganizationList(getOrganizations(organizationTree));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationTree])

    const apiFunctionInfo = () => {
        var i;
        if (creatorType === "municipality") {
            for (i = 0; i < municipalityList.length; i++) {
                if (municipalityList[i].id === selectedFunction.creatorId) {
                    return <p>{t('common.municipality')+" API: "+municipalityList[i].name}</p>
                }
            }
            return <p></p>
        }
        else { //organization
            for (i = 0; i < organizationList.length; i++) {
                if (organizationList[i].id === selectedFunction.creatorId) {
                    return <p>{t('common.organization')+" API: "+organizationList[i].name}</p>
                }
            }
            return <p></p>
        }
    }

    const [open, setOpen] = useState(false);
    const handleButtonClick = () => {
        if(hasPermission(PERMISSION_EDIT_OWN_FUNCTIONS, authenticatedUser) && editorActivated) {
            navigator.clipboard.writeText(new URL(window.location.origin + "/function/createFunction/edit/" + func.selectedFunction.id + "?link=true"))
            setOpen(true);
        } else {
            navigator.clipboard.writeText(new URL(window.location.origin + "/function/createFunction/view/" + func.selectedFunction.id + "?link=true"))
            setOpen(true);
        }
    };

    const handleShareButtonClick = () => {
        navigator.clipboard.writeText(new URL(window.location.origin + "/function/share/" + func.selectedFunction.shareCode + "?link=true"))
        setOpen(true);
    }
    const handleAlertClose = () => {
        setOpen(false);
    };

    const getSharedWith = () => {
        var m = municipalities.find(m => m.id === localFunction.municipalityId);
        if (m) {
            return t('function.shared_with')+m.name;
        }
        return '';
    }

    return (
        <>
            <Grid size={12}>
                <Grid container spacing={1}>
                    {(!localFunction.shared) ? <Grid className="municipality-wrapper-mobile" sx={{display: "flex", alignItems: "center"}} size={12}>
                            <Grid size={12}>
                                <CompPartitionHeader text={headerLabel}/>
                                {isApiFunction && apiFunctionInfo()}
                            </Grid>
                            <Grid className={'align-right'} size={12}>
                                {'id' in localFunction ? (
                                    <TooltipInfo size={'large'} titleText={t('common.copy_link_tooltip')}>
                                    </TooltipInfo>): null}
                                {'id' in localFunction ? (<ButtonPrimary onClick={handleButtonClick}>
                                    {t('common.copy_link')}
                                </ButtonPrimary>) : null}
                                <CustomSnackbar open={open} onClose={handleAlertClose} severity="success" message={t('common.link_copied')} />
                            </Grid>
                            
                        </Grid> :
                        <Grid className="municipality-wrapper-mobile" sx={{display: "flex", alignItems: "center"}} size={12}>
                            <Grid size={12}>
                                <CompPartitionHeader text={t('function.share_header') + (localFunction.shareEventMunicipalityId || action === "share" ? getSharedWith() : '')}/>
                            </Grid>
                            <Grid className="align-right" size={12}>
                               {'id' in localFunction && localFunction.shared && localFunction.shareCode ? (<ButtonPrimary onClick={handleShareButtonClick}>
                                    {t('function.copy_share_link')}
                                </ButtonPrimary>) : null}
                                <ButtonPrimary onClick={handleButtonClick}>
                                    {t('common.copy_link')}
                                </ButtonPrimary>
                                <CustomSnackbar open={open} onClose={handleAlertClose} severity="success" message={t('common.link_copied')} />
                            </Grid>
                        </Grid>}
                </Grid>
            </Grid>
            <Grid size={12}>
                <Grid container spacing={0}>
                    <Grid
                        size={{xs: 12, sm: 6}}>
                        {municipalitySelect ?
                            <CompDropdownNew
                                isLabelShrink={true}
                                label={t('common.municipality')}
                                className={'function-dropdown'}
                                valueColumn={"id"}
                                labelColumn={"name"}
                                rows={municipalityList}
                                hasEmptyOption={false}
                                error={fieldErrors.municipalityId}
                                onChange={handleMunicipalityChange}
                                disabled={!editorActivated}
                                name="municipalityId"
                                selectedValue={selectedFunction.municipalityId ? selectedFunction.municipalityId : authenticatedUser.mainMunicipalityId}
                            />
                            :
                            <CompTextFieldNew
                                label={t('common.municipality')}
                                value={userMunicipality.name}
                                isLabelShrink={true}
                                disabled={true}
                                error={fieldErrors.municipalityId}
                                name="municipalityId"
                            />
                        }
                    </Grid>
                    <Grid size={{xs: 12, sm: 6 }}>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const mapStateToProps = (state) => {
    // return state;
    return {
        municipalities: state.municipality.municipalities,
        func: state.func,
        templates: state.func.templates,
        authenticatedUser: state.auth.authenticatedUser,
        selectedFunction: state.func.selectedFunction,
        organizationTree: state.municipality.organizationTree,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setFunction: (data) => dispatch(setFunction(data)),
        listFunctionTemplates: (municipalityId) => dispatch(listFunctionTemplates(municipalityId)),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getOrganizationTree: (municipalityId, level) => dispatch(getOrganizationTree(municipalityId, level)),
        getSharedMunicipalities: (shareId) => dispatch(getSharedMunicipalities(shareId)),
        listMunicipalityUsersSilent: (municipalityId) => dispatch(listMunicipalityUsersSilent(municipalityId)),
        updateContentIdentifierChoices: (municipalityId) => dispatch(updateContentIdentifierChoices(municipalityId)),
    };
}

export const FunctionMunicipalityComp = connect(
    mapStateToProps,
    mapDispatchToProps)
(FunctionMunicipalityComponent);
